<template>
    <DxForm :label-mode="'outside'" :read-only="false" :show-colon-after-label="true" :label-location="'top'"
        :col-count="1" :min-col-width="300" :width="null">
        <DxSimpleItem data-field="operators" editor-type="dxTagBox" :editor-options="operatorFieldOptions" />
        <DxSimpleItem data-field="areas" editor-type="dxTagBox" :editor-options="areaFieldOptions" />
        <!-- <DxSimpleItem data-field="products" editor-type="dxTagBox" :editor-options="productFieldOptions" /> -->
    </DxForm>
</template>

<script>
import DxForm, { DxSimpleItem } from "devextreme-vue/form";

export default {
    components: {
        DxForm,
        DxSimpleItem,
    },
    props: {
        routes: {
            type: Object,
            required: true
        },
        isEditable: {
            type: Boolean,
            default: false
        },
        allOperators: {
            type: Array,
            default: () => []
        },
        allAreas: {
            type: Array,
            default: () => []
        },
        allProducts: {
            type: Array,
            default: () => []
        },
        containers: {
            type: Array,
            default: () => []
        }
    },
    emits: ['update:routes'],
    computed: {
        filteredOperators() {
            return this.getFilteredItems('operators', ['areas', 'products']);
        },

        filteredAreas() {
            return this.getFilteredItems('areas', ['operators', 'products']);
        },

        filteredProducts() {
            return this.getFilteredItems('products', ['operators', 'areas']);
        },

        operatorFieldOptions() {
            return this.tagBoxEditorOptions(
                "operators",
                "operatorId",
                "operatorName",
                this.filteredOperators,
                this.routes.operators
            );
        },

        areaFieldOptions() {
            return this.tagBoxEditorOptions(
                "areas",
                "areaId",
                "areaName",
                this.filteredAreas,
                this.routes.areas
            );
        },

        productFieldOptions() {
            return this.tagBoxEditorOptions(
                "products",
                "listValue",
                "listValue",
                this.filteredProducts,
                this.routes.products
            );
        },
    },
    methods: {
        getFilteredItems(targetType, filterTypes) {
            if (filterTypes.every(type => this.routes[type].length === 0)) {
                return this[`all${this.capitalize(targetType)}`];
            }

            const typeConfig = {
                operators: {
                    containerProp: 'operator',
                    allItemsProp: 'allOperators',
                    idProp: 'operatorId',
                    nameProp: 'operatorName'
                },
                areas: {
                    containerProp: 'area',
                    allItemsProp: 'allAreas',
                    idProp: 'areaId',
                    nameProp: 'areaName'
                },
                products: {
                    containerProp: 'product',
                    allItemsProp: 'allProducts',
                    idProp: 'listValue',
                    nameProp: 'listValue'
                }
            };

            const matchingContainers = this.containers.filter(container => {
                return filterTypes.every(filterType => {
                    if (this.routes[filterType].length === 0) return true;

                    const config = typeConfig[filterType];

                    if (filterType === 'products') {
                        return this.routes[filterType].includes(container[config.containerProp]);
                    } else {
                        return this.routes[filterType].some(selectedId => {
                            const item = this[config.allItemsProp].find(i => i[config.idProp] === selectedId);
                            return item && container[config.containerProp] === item[config.nameProp];
                        });
                    }
                });
            });

            const targetConfig = typeConfig[targetType];
            const uniqueValues = [...new Set(matchingContainers.map(c => c[targetConfig.containerProp]))];

            if (targetType === 'products') {
                return this[targetConfig.allItemsProp].filter(item =>
                    uniqueValues.includes(item[targetConfig.nameProp])
                );
            } else {
                return this[targetConfig.allItemsProp].filter(item =>
                    uniqueValues.includes(item[targetConfig.nameProp])
                );
            }
        },

        capitalize(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },

        tagBoxEditorOptions(field, fieldVal, fieldDisplay, items, selectedItems) {
            return {
                items: items,
                valueExpr: fieldVal,
                displayExpr: fieldDisplay,
                showSelectionControls: true,
                applyValueMode: "useButtons",
                searchEnabled: true,
                value: selectedItems,
                readOnly: !this.isEditable,
                onValueChanged: ({ value }) => {
                    const newValue = value || [];
                    const currentValue = this.routes[field] || [];
                    const hasChanged = JSON.stringify(newValue.sort()) !== JSON.stringify(currentValue.sort());

                    if (hasChanged) {
                        this.updateRoutes(field, newValue);
                    }
                },
            };
        },

        updateRoutes(field, value) {
            const updatedRoutes = { ...this.routes };
            updatedRoutes[field] = value;
            this.$emit('update:routes', updatedRoutes);
        }
    }
};
</script>
